module.exports = __webpack_public_path__ + "img/Linkedin@2x.7610fc62.png";